export default __webpack_public_path__ + "static/media/1st.6234fa3d.png";